import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const MealCaloriesCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [protein, setProtein] = useState('30,00');
  const [carbs, setCarbs] = useState('50,00');
  const [fat, setFat] = useState('20,00');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const p = parseFloat(parseBrazilianNumber(protein)) || 0;
    const c = parseFloat(parseBrazilianNumber(carbs)) || 0;
    const f = parseFloat(parseBrazilianNumber(fat)) || 0;
    if (p < 0 || c < 0 || f < 0) return;

    const kcalFromProtein = p * 4;
    const kcalFromCarbs = c * 4;
    const kcalFromFat = f * 9;
    const totalKcal = kcalFromProtein + kcalFromCarbs + kcalFromFat;

    const res = { totalKcal, kcalFromProtein, kcalFromCarbs, kcalFromFat };
    setResultState(res);

    onResultChange([
      { label: 'Proteínas', value: `${p.toLocaleString('pt-BR')} g` },
      { label: 'Carboidratos', value: `${c.toLocaleString('pt-BR')} g` },
      { label: 'Gorduras', value: `${f.toLocaleString('pt-BR')} g` },
      { label: 'Total', value: `${totalKcal.toFixed(0)} kcal` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <FormField label="Proteína (g)" placeholder="0,00" value={protein} onChange={setProtein} required isNumeric type="text" />
          <FormField label="Carboidrato (g)" placeholder="0,00" value={carbs} onChange={setCarbs} required isNumeric type="text" />
          <FormField label="Gordura (g)" placeholder="0,00" value={fat} onChange={setFat} required isNumeric type="text" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Calorias
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Total Refeição" value={`${resultState.totalKcal.toFixed(0)} kcal`} color="indigo" />
            <ResultCard title="Calorias Macros" value={`${resultState.kcalFromProtein.toFixed(0)} (P) / ${resultState.kcalFromCarbs.toFixed(0)} (C)`} description="kcal proveniente de P e C" color="blue" />
            <ResultCard title="Gorduras" value={`${resultState.kcalFromFat.toFixed(0)} kcal`} color="amber" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Dicas de Nutrição"
        tips={[
          '1g de proteína fornece 4 calorias',
          '1g de carboidrato fornece 4 calorias',
          '1g de gordura fornece 9 calorias',
          'Equilibrar macros ajuda na saciedade e no rendimento físico'
        ]}
      />
    </div>
  );
};

export default MealCaloriesCalculator;
